//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import React, { useState, useEffect } from "react";
import { useSession } from "../SessionContext";
import axios from "axios";
import { API_URL } from "../../config";
import { uploads } from "../../config";

const BeautyParlourPersonalDetailsForm = () => {
    const { session } = useSession();
    const [show, setShow] = useState(true);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [preview, setPreview] = useState("");

    function changeState() {
        setShow(!show);
    }

    // ✅ GET USER PERSONAL DETAILS
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);
                setFormData(user); // ✅ IMPORTANT: sync editable state

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);

    // ✅ UPDATE API CALL
    const handleSave = () => {

        const isValid = validate();

        if (!isValid) {
            return; // ❌ STOP HERE if invalid
        }

        const payload = {
            user_id: session?.userid,
            user_gender: formData.user_gender,
            dob: formData.dob,
            personal_contactno: formData.personal_contactno,
        };

        axios.post(
            `${API_URL}/api-update-personal-details.php`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        )
            .then((res) => {
                alert("Updated Successfully!");

                setData(formData); // update UI
                setShow(true); // switch back to view mode
            })
            .catch((err) => {
                console.log(err);
                alert("Update Failed!");
            });
    };

    // ✅ FORM VALIDATIONS
    const validate = () => {
        let newErrors = {};

        if (!formData.user_gender) {
            newErrors.user_gender = "Gender is required";
        }

        if (!formData.dob) {
            newErrors.dob = "Date of Birth is required";
        }

        if (!formData.personal_contactno) {
            newErrors.personal_contactno = "Mobile number is required";
        } else if (!/^[6-9]\d{9}$/.test(formData.personal_contactno)) {
            newErrors.personal_contactno = "Enter valid 10-digit mobile number";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div className='bd-right-panel fade-in'>
            <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>

            <div className='comp-details'>
                <div className='logo-box'>
                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                    onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = "/images/default-profile-pic.jpg";
                    }} />
                </div>
                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                <div className='location-box'>
                    <FmdGoodOutlinedIcon />
                    {data?.business_address ? `${data.business_address}, ` : ""}
                    {data?.business_city ? `${data.business_city}, ` : ""}
                    {data?.business_district ? `${data.business_district}, ` : ""}
                    {data?.business_state ? `${data.business_state} - ` : ""}
                    {data?.business_zipcode || ""}
                </div>
            </div>
            <div className='clr'></div>
            <div className='devider'></div>
            <div className='db-form-panel'>
                <div className='heading'>
                    <h2>Personal Details:</h2>
                    {show ? (
                        <div className='edit-btnbox' onClick={changeState} ><EditIcon /> Edit</div>
                    ) : (
                        <div className='close-btnbox' onClick={changeState} ><CloseIcon /> Close</div>
                    )}
                    <div className='clr'></div>
                </div>
                {show ? (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="First Name" value={data?.user_first_name || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Middle Name" value={data?.user_middle_name || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Last Name" value={data?.user_last_name || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Gender" value={data?.user_gender || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Dob" value={data?.dob || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Mobile" value={data?.personal_contactno || ""} /></div></div>
                        </div>
                    </div>
                ) : (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="First Name" value={data?.user_first_name || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Middle Name" value={data?.user_middle_name || ""} /></div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Last Name" value={data?.user_last_name || ""} /></div></div>
                            <div className='col-md-4'>
                                <div className='db-form-row'>
                                    <TextField select className='db-textbox' label="Gender*" value={formData?.user_gender || ""} onChange={(e) => setFormData({ ...formData, user_gender: e.target.value })} error={!!errors.user_gender} helperText={errors.user_gender} >
                                        <MenuItem value="">Select Gender*</MenuItem>
                                        <MenuItem value="Male">Male</MenuItem>
                                        <MenuItem value="Female">Female</MenuItem>
                                        <MenuItem value="Other">Other</MenuItem>
                                    </TextField>
                                </div>
                            </div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className="db-textbox" label="Dob*" value={formData.dob || ""} onChange={(e) => setFormData({ ...formData, dob: e.target.value })} error={!!errors.dob} helperText={errors.dob} /> </div></div>
                            <div className='col-md-4'><div className='db-form-row'><TextField className='db-textbox' label="Mobile*" value={formData?.personal_contactno || ""} onChange={(e) => setFormData({ ...formData, personal_contactno: e.target.value })} error={!!errors.personal_contactno} helperText={errors.personal_contactno} /></div></div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <div style={{ textAlign: "center" }}>
                                        <button onClick={handleSave} className="update-btn">
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default BeautyParlourPersonalDetailsForm
